import { motion } from "framer-motion";

// Masked line-by-line reveal. Accepts array of lines OR children.
export function LineReveal({ lines = [], delay = 0, stagger = 0.08, className = "", as: Tag = "span" }) {
  return (
    <>
      {lines.map((line, i) => (
        <span key={i} className="line-mask">
          <motion.span
            className={className}
            initial={{ y: "110%", opacity: 0 }}
            animate={{ y: "0%", opacity: 1 }}
            transition={{
              duration: 1.05,
              ease: [0.33, 1, 0.68, 1],
              delay: delay + i * stagger,
            }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </>
  );
}

export function WordReveal({ text = "", delay = 0, stagger = 0.05, className = "" }) {
  const words = text.split(" ");
  return (
    <span className="inline-flex flex-wrap">
      {words.map((w, i) => (
        <span key={i} className="line-mask mr-[0.25em]">
          <motion.span
            className={className}
            initial={{ y: "110%", opacity: 0 }}
            animate={{ y: "0%", opacity: 1 }}
            transition={{ duration: 0.9, ease: [0.33, 1, 0.68, 1], delay: delay + i * stagger }}
          >
            {w}
          </motion.span>
        </span>
      ))}
    </span>
  );
}

export function FadeUp({ children, delay = 0, y = 40, className = "" }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.9, ease: [0.33, 1, 0.68, 1], delay }}
    >
      {children}
    </motion.div>
  );
}
